import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import './About.scss';
import '../Basic.scss';
import cn from 'classnames';

import { isAdminControlMode } from '../../../Helpers/ui_helpers';
import { addEvent } from '../../../APIClient/events';

import MetaTags from 'react-meta-tags';
import ScrollToTop from '../../../Components/General/ScrollToTop';
import ArrowButton from '../../../Components/General/Buttons/ArrowButton';

const About = props => {
  const { ui } = props;

  useEffect(() => {
    !isAdminControlMode(ui) && addEvent('About Us - Page View');
  }, []);

  return (
    <div className='about-outer-container'>
      <ScrollToTop />
      <MetaTags>
        <title>Our Story | ShopMy</title>
        <meta
          property='description'
          content='Redefining the future of curated commerce.'
        />
      </MetaTags>
      <div className='about-headline-info-container'>
        <img className='about-headline-info-background-img' src='https://static.shopmy.us/about-headline-info-background-image.png' alt='' />
        <h1 className='about-section-header-small'>About Us</h1>
        <div className='about-headline-info-headline'>
          <i>Redefining</i> the future of curated commerce.
        </div>
        <div className='about-headline-info-stats-container'>
          <div className='about-headline-info-stat'>
            <div className='about-headline-info-stat-value'>2020</div>
            <div className='about-label-text'>Launched</div>
          </div>
          <div className='about-headline-info-stat'>
            <div className='about-headline-info-stat-value'>$750M</div>
            <div className='about-label-text'>Volume Driven</div>
          </div>
          <div className='about-headline-info-stat'>
            <div className='about-headline-info-stat-value'>150K</div>
            <div className='about-label-text'>Creators</div>
          </div>
          <div className='about-headline-info-stat'>
            <div className='about-headline-info-stat-value'>40K</div>
            <div className='about-label-text'>Brand Partners</div>
          </div>
        </div>
      </div>
      <div className='about-our-team-container'>
        <h1 className='about-section-header-small'>Our Team</h1>
        <div className='about-our-team-description-container'>
          <div className={cn('about-our-team-description-large', 'about-section-header-large')}>
            Born from a research project at MIT and headquartered in New York, we’re not just building tools — we’re shaping a cultural shift.
          </div>
          <div className='about-our-team-description-small-container'>
            <div className='about-our-team-description-small'>
              Our team of engineers, designers, and industry minds is united by one belief: that taste is a form of intelligence. 
              We build with that in mind — crafting technology that connects creators, brands, and shoppers through curated, trusted recommendations. 
              Not ads. Not algorithms. Real influence, shared with purpose.
            </div>
          </div>
        </div>
        <div className='about-our-team-founders-container'>
          <div className='about-our-team-founder' onClick={() => window.open('https://shopmy.us/Ctinsley124', '_blank')}>
            <img className='about-our-team-founder-image' src='https://static.shopmy.us/founder-headshot-chris.png' alt='Chris Tinsley' />
            <div className='about-our-team-founder-text'>
              <div className='about-our-team-founder-name'>Chris Tinsley</div>
              <div className='about-our-team-founder-title'>Founder, Chief Business Development Officer</div>
            </div>
          </div>
          <div className='about-our-team-founder' onClick={() => window.open('https://shopmy.us/tiffany', '_blank')}>
            <img className='about-our-team-founder-image' src='https://static.shopmy.us/founder-headshot-tiffany.png' alt='Tiffany Lopinsky' />
            <div className='about-our-team-founder-text'>
              <div className='about-our-team-founder-name'>Tiffany Lopinsky</div>
              <div className='about-our-team-founder-title'>Founder, President</div>
            </div>
          </div>
          <div className='about-our-team-founder' onClick={() => window.open('https://shopmy.us/harryrein', '_blank')}>
            <img className='about-our-team-founder-image' src='https://static.shopmy.us/founder-headshot-harry.png' alt='Harry Rein' />
            <div className='about-our-team-founder-text'>
              <div className='about-our-team-founder-name'>Harry Rein</div>
              <div className='about-our-team-founder-title'>Founder, CEO</div>
            </div>
          </div>
        </div>
      </div>
      <div className='about-in-the-press-container'>
        <div className='about-in-the-press-header'>
          <span className={cn('about-in-the-press-header-text', 'about-section-header-large')}>In the Press</span>
          <span className='about-in-the-press-header-line'/>
        </div>
        <div className='about-in-the-press-articles-container'>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/forbes.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                Affiliate Marketing Gets a Makeover: A Stylish New Growth Strategy
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://www.forbes.com/sites/jamiegutfreund/2024/09/20/affiliate-marketing-gets-a-makeover-a-stylish-new-growth-strategy/'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/bof.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                ShopMy Puts Its Spin on the Sponsored Post
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://www.businessoffashion.com/news/marketing-pr/shop-my-put-its-spin-on-the-sponsored-posts/'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/beauty-matter.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                Meet the NEXT 2024 Innovator of the Year Finalists
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://beautymatter.com/articles/next-2024-innovator-of-the-year-finalists'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/bof.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                The Fight for Influencer Marketing Dollars Heats Up
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://www.businessoffashion.com/articles/marketing-pr/the-fight-for-influencer-marketing-dollars-heats-up/'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/glossy.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                Glossy Fashion & Luxury Awards finalists
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://www.glossy.co/announcement/awards/hm-aldo-loveshack-fancy-and-stanley-are-glossy-fashion-luxury-awards-finalists/'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
          <div className='about-in-the-press-article'>
            <div className='about-in-the-press-article-logo-container'>
              <img className='about-in-the-press-article-logo' src='https://static.shopmy.us/Brand%2BLogos/the-information.svg'/>
            </div>
            <div className='about-in-the-press-article-inner-container'>
              <div className='about-in-the-press-article-title'>
                How a Social Shopping Startup Is Gaining Ground
              </div>
              <a 
                className={cn('about-in-the-press-article-read-more-link', 'about-label-text')}
                href='https://www.theinformation.com/articles/how-a-social-shopping-startup-is-gaining-ground'
                target='_blank'
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='about-our-mission-container'>
        <div className='about-our-mission-content-container'>
          <div className='about-section-header-small'>Our Mission</div>
          <div className={cn('about-our-mission-description-large', 'about-section-header-large')}>
            We believe the most compelling marketing doesn’t feel like marketing at all.
          </div>
          <div className='about-our-mission-description-small'>
            It’s a celebration: of standout products, thoughtful curation, and voices you trust. 
            We’re here to bring that vision to life, by empowering creators to share what they genuinely love.
          </div>
          <div className='about-our-mission-button-container'>
            <ArrowButton displayText='For Brands' href='/home/brands' noDivider />
            <ArrowButton displayText='For Creators' href='/home/creators' noDivider />
            {window.__NEW_SHOP_MODE__ && <ArrowButton displayText='For Shoppers' href='/home/shoppers' noDivider />}
          </div>
        </div>
        <img className='about-our-mission-image' src='https://static.shopmy.us/about-our-mission-cloth.png' alt=""/>
      </div>
      <div className='about-open-positions-container'>
        <div className='about-section-header-large'>Join our team</div>
        <ArrowButton displayText='Open Positions' href='/careers' noDivider />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { ui } = state;
  return { ui };
};

export default connect(mapStateToProps, {})(About);
